'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'handshake';
var width = 576;
var height = 512;
var aliases = [129309,62662,"handshake-alt","handshake-simple"];
var unicode = 'f2b5';
var svgPathData = ['M32 55.7l75.3 54.8c3.2 2.3 7.6 2 10.4-.8l3.9-3.9C138 89.3 160.4 80 183.8 80l84.9 0-119 119c-9.4 9.4-9.4 24.6 0 33.9l.8 .8c40.6 40.6 106.5 40.6 147.1 0L336 195.3 445.1 304.4c21.9 21.9 21.9 57.3 0 79.2l-29.1 29.1-34.3-34.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L404 423.3c-20.8 16-46.4 24.7-73 24.7l-23.7 0-37.7-37.7c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l26.3 26.3-39.7 0c-31.8 0-62.3-12.6-84.9-35.1L32 284.7 32 55.7zM161 210.3L291.3 80 386.9 80c17.4 0 34.4 5.1 48.8 14.8l23.8 15.9c2.8 1.9 6.4 1.8 9.1-.2l75.3-54.8 0 229-66.9 66.9c2.2-20.9-4.7-42.5-20.7-58.5L341.7 178.3c-3.1-3.1-8.2-3.1-11.3 0l-44.1 44.1c-34.4 34.4-90.1 34.4-124.5 0l-.8-.8c-3.1-3.1-3.1-8.2 0-11.3z', 'M558.5 35.3c2.6 3.6 1.8 8.6-1.8 11.2l-88 64c-2.7 2-6.4 2-9.1 .2L435.7 94.8C421.3 85.1 404.3 80 386.9 80L291.3 80 161 210.3c-3.1 3.1-3.1 8.2 0 11.3l.8 .8c34.4 34.4 90.1 34.4 124.5 0l44.1-44.1c3.1-3.1 8.2-3.1 11.3 0L456.4 293.1c16 16 22.9 37.6 20.7 58.5l77.3-77.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L456.4 394.9c-5.9 5.9-15.6 15.6-29.3 29.3-25.5 25.5-60.1 39.8-96.2 39.8l-86 0c-36.1 0-70.7-14.3-96.2-39.8L10.3 285.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L160.2 412.9c22.5 22.5 53 35.1 84.9 35.1l39.7 0-26.3-26.3c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l37.7 37.7 23.7 0c26.5 0 52.1-8.8 73-24.7l-33.6-33.6c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l34.3 34.3 29.1-29.1c21.9-21.9 21.9-57.3 0-79.2L336 195.3 297.5 233.8c-40.6 40.6-106.5 40.6-147.1 0l-.8-.8c-9.4-9.4-9.4-24.6 0-33.9l119-119-84.9 0c-23.3 0-45.7 9.3-62.2 25.8l-3.9 3.9c-2.8 2.8-7.2 3.1-10.4 .8l-88-64c-3.6-2.6-4.4-7.6-1.8-11.2s7.6-4.4 11.2-1.8l82.5 60C130.6 74.6 156.6 64 183.8 64l203.2 0c20.5 0 40.6 6.1 57.7 17.5l19.2 12.8 83.5-60.7c3.6-2.6 8.6-1.8 11.2 1.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHandshake = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;